import React from 'react'

import Image from 'next/image'
import { Carousel } from 'react-responsive-carousel'
import { s3Static } from '../../../utils/constants'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

export const PersonalTrainerPackageImages = (props) => {
    let listing = props.listing

  return (
    <div>
        <div className='relative h-full w-full'>
            <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false}>
                {[...listing.listingImagesArray].map((images, j) =>
                    <div className='relative aspect-4/3 w-full' key={j}>    
                        <Image className=''
                            src={images.image}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt={'Listing - ' + listing.title}
                        />  
                    </div>                                                           
                )}
            </Carousel>
            {listing.discountPercent > 0 && 
                <div className='absolute top-0 '>
                    <div className='h-16 w-16 text-sm sm:text-base sm:h-20 sm:w-20 bg-linear-to-tr from-red-900 to bg-red-400 rounded-full'>
                        <span className='absolute text-white left-0 right-0 top-1/5 text-center'>{listing.discountPercent}%
                            <br/>OFF</span>
                    </div>
                </div>   
            }
        </div>
        {listing.listingImagesArray.length === 0 &&
            (
                <div className='relative aspect-4/3 w-full'>    
                        {listing.discountPercent > 60 &&
                            <Image className=''
                                src={s3Static + "personal-trainer/personal-fitness-trainer.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt={'Listing - ' + listing.title}
                            />
                        }
                        {(listing.discountPercent > 40 && listing.discountPercent <= 60) &&
                            <Image className=''
                                src={s3Static + "fitness-package2.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt={'Listing - ' + listing.title}
                            />
                        }
                        {(listing.discountPercent > 10 && listing.discountPercent <= 40) &&
                            <Image className=''
                                src={s3Static + "fitness-package6.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt={'Listing - ' + listing.title}
                            />
                        }
                        {(listing.discountPercent <= 10) &&
                            <Image className=''
                                src={s3Static + "personal-trainer/fitness-trainer-singapore.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt={'Listing - ' + listing.title}
                            />
                        }
                        {listing.discountPercent > 0 && 
                            <div className='absolute top-0 '>
                                <div className='h-16 w-16 text-sm sm:text-base sm:h-20 sm:w-20 bg-linear-to-tr from-red-900 to bg-red-400 rounded-full'>
                                    <span className='absolute text-white left-0 right-0 top-1/5 text-center'>{listing.discountPercent}%
                                        <br/>OFF</span>
                                </div>
                            </div>   
                        }
                        
                </div>  
            )
        }
    </div>
  )
}
